/* GSO PDP v2 Shopify interactions. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function moneyFromCents(cents) {
    if (!window.theme || !theme.Currency || !theme.settings) return '';
    return theme.Currency.formatMoney(parseInt(cents, 10), theme.settings.moneyFormat);
  }

  function initGallery(root) {
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        main.src = thumb.getAttribute('data-full') || (img && img.src) || main.src;
        main.alt = img ? img.alt : main.alt;
        thumbs.forEach(function (item) { item.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function setAddedState(button) {
    if (!button) return;
    button.classList.add('is-added');
    setTimeout(function () { button.classList.remove('is-added'); }, 1600);
  }

  function initProductForm(root) {
    var form = root.querySelector('.gso-product-form');
    var cards = root.querySelectorAll('[data-variant-card]');
    var select = root.querySelector('[data-gso-product-select]');
    var mainPrice = root.querySelector('[data-price-main]');
    var comparePrice = root.querySelector('[data-compare-main]');
    var saveLabel = root.querySelector('[data-save-main]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var atcMainText = root.querySelector('[data-atc-main] [data-add-to-cart-text]');
    var atcSticky = root.querySelector('[data-atc-sticky]');
    var paypal = root.querySelector('[data-pp-message]');

    function apply(card) {
      if (!card || card.disabled || card.classList.contains('is-unavailable')) return;

      cards.forEach(function (item) {
        item.classList.toggle('is-active', item === card);
        item.setAttribute('aria-pressed', item === card ? 'true' : 'false');
      });

      var priceLabel = card.getAttribute('data-price-label') || moneyFromCents(card.getAttribute('data-price'));
      var compareLabel = card.getAttribute('data-compare-label');
      var saveLabelText = card.getAttribute('data-save-label');
      var size = card.getAttribute('data-size') || '';
      var variantId = card.getAttribute('data-variant-id');

      if (select && variantId) select.value = variantId;
      if (mainPrice) mainPrice.textContent = priceLabel;
      if (comparePrice) {
        comparePrice.textContent = compareLabel || '';
        comparePrice.style.display = compareLabel ? '' : 'none';
      }
      if (saveLabel) {
        saveLabel.textContent = saveLabelText || '';
        saveLabel.style.display = saveLabelText ? '' : 'none';
      }
      if (stickyPrice) stickyPrice.textContent = size + ' · ' + priceLabel;
      if (atcMainText) atcMainText.textContent = 'Add to cart · ' + priceLabel;
      if (atcSticky) atcSticky.textContent = 'Add · ' + priceLabel;
      if (paypal && card.getAttribute('data-price')) {
        paypal.setAttribute('data-pp-amount', (parseInt(card.getAttribute('data-price'), 10) / 100).toFixed(2));
      }
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { apply(card); });
    });

    var active = root.querySelector('[data-variant-card].is-active') || cards[0];
    if (active) apply(active);

    if (form && window.theme && theme.AjaxProduct && !form.dataset.gsoAjaxProduct) {
      form.dataset.gsoAjaxProduct = 'true';
      new theme.AjaxProduct(form, '[data-add-to-cart]');
      form.addEventListener('ajaxProduct:added', function (evt) {
        setAddedState(evt.detail && evt.detail.addToCartBtn);
        document.dispatchEvent(new CustomEvent('cart:build'));
      });
    }

    if (form && atcSticky) {
      atcSticky.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }

  function initQty(root) {
    root.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (!input || !minus || !plus) return;
      var max = parseInt(input.getAttribute('max'), 10) || 999;
      minus.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      plus.addEventListener('click', function () {
        input.value = Math.min(max, (parseInt(input.value, 10) || 1) + 1);
      });
    });
  }

  function initCompare(root) {
    root.querySelectorAll('[data-compare]').forEach(function (compare) {
      var after = compare.querySelector('.compare__after');
      var handle = compare.querySelector('.compare__handle');
      var range = compare.querySelector('.compare__range');
      if (!after || !handle || !range) return;
      function set(percent) {
        percent = Math.max(0, Math.min(100, percent));
        after.style.clipPath = 'inset(0 0 0 ' + percent + '%)';
        handle.style.left = percent + '%';
      }
      range.addEventListener('input', function () { set(parseFloat(range.value)); });
      set(parseFloat(range.value || 50));
    });
  }

  function initStickyATC(root) {
    var bar = root.querySelector('[data-sticky-atc]');
    var anchor = root.querySelector('[data-atc-main]') || root.querySelector('[data-atc-anchor]');
    if (!bar || !anchor) return;
    var stickyButton = bar.querySelector('[data-atc-sticky]');
    var ticking = false;
    var badgeCandidates = null;

    function badgeElements() {
      if (badgeCandidates) return badgeCandidates;
      badgeCandidates = Array.prototype.slice.call(document.body.querySelectorAll('*')).filter(function (el) {
        if (root.contains(el) || bar.contains(el)) return false;
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') return false;
        var rect = el.getBoundingClientRect();
        return rect.width >= 36 &&
          rect.width <= 190 &&
          rect.height >= 24 &&
          rect.height <= 92 &&
          rect.left <= 150 &&
          rect.bottom >= window.innerHeight - 120;
      });
      return badgeCandidates;
    }

    function adjustFixedBadges(showing) {
      if (window.innerWidth > 768) return;
      badgeElements().forEach(function (el) {
        if (el.dataset.gsoPdpOriginalBottom === undefined) {
          el.dataset.gsoPdpOriginalBottom = el.style.bottom || '';
        }
        if (showing) {
          el.style.setProperty('bottom', '86px', 'important');
        } else {
          el.style.bottom = el.dataset.gsoPdpOriginalBottom;
        }
      });
    }

    function update() {
      ticking = false;
      var rect = anchor.getBoundingClientRect();
      var nearFooter = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 220);
      var showing = rect.bottom < 0 && !nearFooter;
      bar.classList.toggle('show', showing);
      bar.setAttribute('aria-hidden', showing ? 'false' : 'true');
      if (stickyButton) stickyButton.tabIndex = showing ? 0 : -1;
      document.body.classList.toggle('gso-pdp-v2-sticky-visible', showing);
      adjustFixedBadges(showing);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    window.addEventListener('resize', function () {
      badgeCandidates = null;
      update();
    });
    update();
  }

  function initCalc(root) {
    var form = root.querySelector('[data-calc]');
    if (!form) return;
    var input = form.querySelector('input');
    var out = form.querySelector('[data-calc-out]');
    var rateLow = parseFloat(form.getAttribute('data-rate-low')) || 25;
    var rateHigh = parseFloat(form.getAttribute('data-rate-high')) || 35;
    if (!input || !out) return;
    function calc() {
      var area = parseFloat(input.value);
      if (!area || area <= 0) {
        out.innerHTML = 'Enter your lawn size to see how much seed you need.';
        return;
      }
      var lo = Math.round(area * rateLow / 1000 * 10) / 10;
      var hi = Math.round(area * rateHigh / 1000 * 10) / 10;
      out.innerHTML = 'You need roughly <b>' + lo + '–' + hi + ' kg</b> of seed for <b>' + area + ' m²</b>.';
    }
    input.addEventListener('input', calc);
    calc();
  }

  function initDetailLayer(root) {
    var planner = root.querySelector('[data-planner-target]');
    if (planner) {
      ['.tools-grid'].forEach(function (selector) {
        var block = root.querySelector(selector);
        if (!block || planner.contains(block)) return;
        var sourceSection = block.closest('[data-planner-section]') || block.closest('.pdp-section');
        block.classList.add('planner__moved-block');
        planner.appendChild(block);
        planner.classList.add('planner-shell--tools-only');
        if (sourceSection) sourceSection.hidden = true;
      });
    }

    var tabs = root.querySelector('[data-detail-tabs]');
    if (!tabs) return;
    var panels = Array.prototype.slice.call(tabs.querySelectorAll('[data-detail-target]'));
    var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[data-detail-tab]'));

    root.querySelectorAll('[data-detail-panel]').forEach(function (section) {
      var key = section.getAttribute('data-detail-panel');
      var target = tabs.querySelector('[data-detail-target="' + key + '"]');
      if (!target || target.contains(section)) return;
      section.classList.add('pdp-section--embedded');
      target.appendChild(section);
    });

    function activate(key, shouldScroll, hashId) {
      buttons.forEach(function (button) {
        var active = button.getAttribute('data-detail-tab') === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-detail-target') === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (shouldScroll) {
        var target = hashId ? document.getElementById(hashId) : tabs;
        if (target) setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 30);
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        activate(button.getAttribute('data-detail-tab'), false);
      });
    });

    function activateForHash(shouldScroll) {
      var hash = window.location.hash ? window.location.hash.slice(1) : '';
      if (!hash) return false;
      var target = document.getElementById(hash);
      if (!target || !root.contains(target)) return false;
      var panel = target.closest('[data-detail-target]');
      if (!panel) return false;
      activate(panel.getAttribute('data-detail-target'), shouldScroll, hash);
      return true;
    }

    if (!activateForHash(false)) activate((buttons[0] && buttons[0].getAttribute('data-detail-tab')) || 'bag', false);
    window.addEventListener('hashchange', function () { activateForHash(true); });
  }

  ready(function () {
    document.querySelectorAll('[data-gso-pdp-v2]').forEach(function (root) {
      document.body.classList.add('gso-pdp-v2-active');
      initGallery(root);
      initProductForm(root);
      initQty(root);
      initDetailLayer(root);
      initCompare(root);
      initStickyATC(root);
      initCalc(root);
    });
  });
})();
